export function megaNav() {
  const nav = document.querySelector(".js-mega-nav");
  if (!nav) return;

  const items = nav.querySelectorAll(".js-mega-nav__item");

  function closeItem(item) {
    item.classList.remove("is-active");
    const trigger = item.querySelector(".js-mega-nav__trigger");
    if (trigger) trigger.setAttribute("aria-expanded", "false");
    const panel = item.querySelector(".mega-nav__panel");
    if (panel) panel.style.maxHeight = "";
  }

  function openItem(item) {
    items.forEach((other) => {
      if (other !== item) closeItem(other);
    });
    item.classList.add("is-active");
    const trigger = item.querySelector(".js-mega-nav__trigger");
    if (trigger) trigger.setAttribute("aria-expanded", "true");
    const panel = item.querySelector(".mega-nav__panel");
    if (panel) panel.style.maxHeight = panel.scrollHeight + "px";
    nav.classList.add("is-open");
  }

  items.forEach((item) => {
    const trigger = item.querySelector(".js-mega-nav__trigger");
    if (!trigger) return;

    trigger.addEventListener("click", () => {
      if (item.classList.contains("is-active")) {
        closeItem(item);
        nav.classList.remove("is-open");
      } else {
        openItem(item);
      }
    });
  });

  document.addEventListener("click", (e) => {
    if (nav.contains(e.target)) return;
    items.forEach(closeItem);
    nav.classList.remove("is-open");
  });

  window.addEventListener(
    "scroll",
    () => {
      items.forEach(closeItem);
      nav.classList.remove("is-open");
    },
    { passive: true },
  );
}
